import React from 'react'
import { Button, ButtonGroup } from 'syft-acp-atoms/Button'
import { Link } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import * as conductReviewsActions from 'syft-acp-core/store/conductReviews/actions'
import RecordControls from 'syft-acp-core/components/RecordSection/RecordControls'
import LoadingIndicator from 'syft-acp-util/components/LoadingIndicator'

import { trackingEvents } from '../BanReviewDetail.tracking'
import { BanReviewDetailControlsProps as Props } from './BanReviewDetailControls.types'
import { useTrackingTrigger } from '@indeed/flex-tracking-context'

export const storeConnector = connect(
  ({ conductReviews: { isSavingData, isLoadingData } }) => ({
    isSavingData,
    isLoadingData,
  }),
  dispatch => ({
    actions: bindActionCreators(conductReviewsActions, dispatch),
  }),
)

const defaultData = {
  notes: '',
  outcome: null,
  ban_reason_id: null,
}

const getFinalOutcome = (outcome?: string) => {
  if (!outcome) return undefined
  if (outcome === 'no_ban') return 'no_ban'
  return 'ban'
}

const BanReviewDetailControls = ({
  actions,
  data = defaultData,
  id = 0,
  isSavingData,
  isLoadingData,
  isPristine,
}: Props) => {
  const triggerEvent = useTrackingTrigger()
  const { notes, outcome } = data as any
  const isClosed = isPristine && !!outcome

  const saveAction = () => {
    triggerEvent(trackingEvents.SAVE.CLICKED, { conduct_review_id: id })
    const finalOutcome = getFinalOutcome(outcome)
    if (id)
      actions.updateConductReview(id, {
        notes: notes ?? '',
        outcome: finalOutcome,
        ban_reason_id: finalOutcome === 'ban' ? outcome : undefined,
        assignee_id: Number(data?.assignee?.id),
      })
  }

  const onClickBack = () => {
    triggerEvent(trackingEvents.BACK.CLICKED, { conduct_review_id: id })
  }

  return (
    <RecordControls>
      <div className="spacer">
        <ButtonGroup>
          <Link to={`/conduct/ban-reviews/list`}>
            <Button onClick={onClickBack}>Back to ban reviews</Button>
          </Link>
        </ButtonGroup>
      </div>
      <div className="right">
        <LoadingIndicator loadingState={isSavingData || isLoadingData} />{' '}
        <ButtonGroup>
          {!isClosed && (
            <Button kind="success" onClick={saveAction} disabled={isSavingData || isPristine}>
              Save
            </Button>
          )}
        </ButtonGroup>
      </div>
    </RecordControls>
  )
}

export default storeConnector(BanReviewDetailControls)
